export const formatPrice = (value, currency = null, hideDecimals = false) => {
  const options = {
    style: 'currency',
    currency: currency ?? window.Phoenix.currencyCode,
  };

  if (hideDecimals) {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }

  return new Intl.NumberFormat(window.Phoenix.laravelLocale, options).format(value);
};

export const formatPercentage = (value) => (value * 100).toFixed(2);
